import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowUpRight, Storefront, ChartLineUp, Users } from "@phosphor-icons/react";
import { fadeUp, stagger, viewport } from "../../lib/motion";

const perks = [
  { icon: Users, title: "Mais clientes", desc: "Apareça para toda a cidade de Maracás no app mais usado da região." },
  { icon: ChartLineUp, title: "Gestão fácil", desc: "Painel do lojista para gerenciar cardápio, pedidos e horários." },
  { icon: Storefront, title: "Sua loja online", desc: "Comece a vender pelo delivery sem complicação e sem taxa de adesão." },
];

export const Lojistas = () => (
  <section id="lojistas" className="relative overflow-hidden bg-maraca-navy py-24 text-white md:py-32" data-testid="lojistas-section">
    <div className="pointer-events-none absolute -right-20 -top-20 h-96 w-96 rounded-full bg-maraca-teal/20 blur-3xl" />
    <div className="pointer-events-none absolute -bottom-24 -left-24 h-96 w-96 rounded-full bg-maraca-pink/20 blur-3xl" />

    <div className="mx-auto grid max-w-8xl items-center gap-14 px-5 md:grid-cols-2 md:px-10">
      <div>
        <p className="mb-3 font-mono text-xs font-bold uppercase tracking-[0.2em] text-maraca-amber">
          Para lojistas
        </p>
        <h2 className="font-display text-4xl font-extrabold leading-[0.95] tracking-tight md:text-5xl lg:text-6xl">
          Coloque sua loja no <span className="text-maraca-teal">Delivery Maracás</span>
        </h2>
        <p className="mt-5 max-w-md text-lg text-white/70">
          Restaurantes, mercados, farmácias e serviços: cadastre-se e comece a
          receber pedidos de toda a cidade pelo nosso app.
        </p>

        <Link
          to="/cadastro"
          data-testid="cadastre-loja-cta"
          className="group mt-8 inline-flex items-center gap-2 rounded-full bg-maraca-amber px-7 py-4 font-display text-lg font-bold text-maraca-navy transition-transform duration-300 hover:-translate-y-1 focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-maraca-navy"
        >
          Cadastre sua loja
          <ArrowUpRight size={22} weight="bold" className="transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
        </Link>
        <p className="mt-3 text-sm text-white/50">Cadastro rápido, com envio de logo e capa da loja.</p>
      </div>

      <motion.div variants={stagger} initial="hidden" whileInView="show" viewport={viewport} className="grid gap-5">
        {perks.map((p) => (
          <motion.div
            key={p.title}
            variants={fadeUp}
            className="flex items-start gap-5 rounded-2xl border border-white/10 bg-white/5 p-6 backdrop-blur-sm"
          >
            <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-maraca-teal/20">
              <p.icon size={26} weight="duotone" className="text-maraca-teal" />
            </span>
            <div>
              <h3 className="font-display text-xl font-bold">{p.title}</h3>
              <p className="mt-1 text-white/70">{p.desc}</p>
            </div>
          </motion.div>
        ))}
      </motion.div>
    </div>
  </section>
);
